import type { AsyncResolverDeps } from "./types";

export type AsyncSourceName = "season" | "welle";

export type AsyncResolver = (field: string, deps: AsyncResolverDeps) => Promise<string>;

const ASYNC_SOURCE_NAMES = ["season", "welle"] as const satisfies readonly AsyncSourceName[];

const hasTokenData = (v: unknown): v is { data?: { token?: string } } =>
  typeof v === "object" && v !== null && "data" in v;

const createPartnerTokenResolver =
  (integration: "Season" | "Welle"): AsyncResolver =>
  async (field, { session }) => {
    if (field !== "token") {
      throw new Error(`Unknown ${integration.toLowerCase()} field: ${field}`);
    }
    const result = await session.api.integrations.proxy_read({
      integration,
      type: "partner-redirect-token",
    });
    const token = hasTokenData(result) ? result.data?.token : undefined;
    if (typeof token !== "string" || token.length === 0) {
      throw new Error(`${integration} partner-redirect response did not include a token`);
    }
    return token;
  };

export const ASYNC_RESOLVERS: Record<AsyncSourceName, AsyncResolver> = {
  season: createPartnerTokenResolver("Season"),
  welle: createPartnerTokenResolver("Welle"),
};

export const ASYNC_SOURCES: ReadonlySet<string> = new Set<AsyncSourceName>(ASYNC_SOURCE_NAMES);

export const isAsyncSource = (source: string): source is AsyncSourceName => ASYNC_SOURCES.has(source);
